import { RenderElementProps } from 'slate-react';

export const ELEMENT_OUTLINE_PARAGRAPH = 'outline-paragraph';
export const ELEMENT_OUTLINE_PARAGRAPH_TITLE = 'outline-paragraph-title';
export const ELEMENT_OUTLINE_PARAGRAPH_IDEA_CONTAINER_TITLE =
  'outline-paragraph-idea-container-title';
export const ELEMENT_OUTLINE_PARAGRAPH_IDEA_CONTAINER = 'outline-paragraph-idea-container';

export const ELEMENT_OUTLINE_PARAGRAPH_IDEA = 'outline-paragraph-idea';
export const ELEMENT_OUTLINE_PARAGRAPH_IDEA_TITLE = 'outline-paragraph-idea-title';
export const ELEMENT_OUTLINE_PARAGRAPH_IDEA_BULLET_LIST = 'outline-paragraph-idea-bullet-list';
export const ELEMENT_OUTLINE_PARAGRAPH_IDEA_LIST_ITEM = 'outline-paragraph-idea-list-item';

export interface OutlineParagraphPluginOptions {
  isReadOnly?: boolean;
}

export interface BaseOutlineParagraphProps
  extends RenderElementProps,
    OutlineParagraphPluginOptions {}
